import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext } from "utils/Constant";
import { ApiDeleteBank, ApiGetBankList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";

export default function Bank(){
    let navigate = useNavigate()

    const { data: bankList, fetch: getBankList } = useFetch(ApiGetBankList)
    const { fetch: deleteBank } = useFetch(ApiDeleteBank)

    const [bankCode, setBankCode] = useState(EmptyString)
    const [bankName, setBankName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)

    const bankCodeChange = (e) => { setBankCode(e.target.value.toUpperCase()) }
    const bankNameChange = (e) => { setBankName(e.target.value.toUpperCase()) }
    const statusChange = (e) => { setStatus(e.value) }
    const filterEnterKeyPress = (e) => { fEnterKeyDown(e) }
    const addBtnClick = () => { navigate("/setting/bank/form?bankId=&formType=" + FormTypeAdd) }
    const searchBtnClick = () => { fBindGrid(0) }

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        fBindGrid(0)
    },[])

    // Function Api Call
    async function fGetBankList(index){
        let res

        await getBankList({
            data: {
                bankCode: bankCode,
                bankName: bankName, 
                status: status,
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }
    async function fDeleteBank(bankId, status){
        await deleteBank({
            data: {
                bankId: bankId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { setSuccessModal({  isOpen: false }) }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Button
    function fEditBtnClick(bankId){
        navigate("/setting/bank/form?bankId=" + bankId + "&formType=Edit")
    }
    function fDeleteBtnClick(bankId, status){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    fDeleteBank(bankId, status).then(() => {
                        fBindGrid(pageIndex)
                    })
                }
            }
        })
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fGetBankList(i).then((res) => {
            if (res !== null && typeof res !== 'undefined'){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Bank</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-2 w-full">
                        <span>Bank Code</span>
                        <input className="input" value={bankCode} onChange={bankCodeChange} onKeyDown={filterEnterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>Bank Name</span>
                        <input className="input" value={bankName} onChange={bankNameChange} onKeyDown={filterEnterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={statusChange} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Bank Code</th>
                            <th className="font-semibold text-left px-2">Bank Name</th>
                            <th className="font-semibold text-left px-2">Call Center</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {bankList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.bankCode.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.bankName.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.callCenter }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => fEditBtnClick( data.bankId )}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === "2" ? "hidden" : "block" }`} onClick={() => fDeleteBtnClick(data.bankId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === "1" ? 'hidden' : 'block' }`} onClick={() => fDeleteBtnClick(data.bankId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}